<script setup lang="ts">
import { ref, defineProps, computed, watch, onMounted } from 'vue';
import Comment from './Comment.vue';

const props = defineProps<{
  point: any;
}>();

const lastCommentRef = ref<HTMLDivElement | null>(null);
const yTranslate = ref(false);
const xTranslate = ref(false);
const marginTop = ref(0);

const comment = computed(() => {
  if (props.point.comments.length <= 0) {
    return null;
  }

  let _comment = props.point.comments[props.point.comments.length - 1];
  return { ..._comment.comment, sender: _comment.sender };
});

const calculateStyle = () => {
  const drawingArea = document.querySelector('.drawing-area').getBoundingClientRect();
  const bounds = lastCommentRef.value?.getBoundingClientRect();

  if (bounds) {
    const windowSize = { height: window.innerHeight, width: window.innerWidth };
    const x = (props.point.left * drawingArea.width) / 100 + drawingArea.x - bounds.width - 11 - 8;
    const y = (props.point.top * drawingArea.height) / 100 + drawingArea.y + 13 + 8;

    xTranslate.value = x < 14 + 8;
    // yTranslate.value = y + bounds.height > windowSize.height - 14;

    if (y + bounds.height > windowSize.height - 14 - 8) {
      marginTop.value = windowSize.height - 14 - 8 - y - bounds.height;
    } else {
      marginTop.value = 0;
    }
  } else {
    marginTop.value = 0;
  }
};

onMounted(calculateStyle);
</script>

<template>
  <div
    ref="lastCommentRef"
    class="last-comment shadow-menu-s bg-white dark:bg-gray-900"
    :style="{ left: point.left + '%', top: point.top + '%', 'margin-top': marginTop }"
    :class="{ 'translate-x': xTranslate, 'translate-y': yTranslate }"
  >
    <Comment v-if="comment" :comment="comment" :can-highlight="false" :preview="true"></Comment>
  </div>
</template>

<style scoped lang="scss">
$inter-font: 'Inter', sans-serif;

.last-comment {
  position: absolute;
  border-radius: 8px;
  width: 275px;
  z-index: 1002;
  font-family: $inter-font;
  max-height: 500px;
  display: flex;
  flex-direction: column;
  transform: translate(calc((100% + 19px) * -1), 21px);
  padding: 12px 16px;
  overflow: hidden;

  &.translate-x {
    transform: translate(19px, 21px);
  }

  &.translate-y {
    transform: translate(calc((100% + 19px) * -1), calc((100% + 21px) * -1));
  }

  &.translate-x.translate-y {
    transform: translate(19px, calc((100% + 21px) * -1));
  }
}
</style>
